import React from 'react';
import { Pie } from 'react-chartjs-2';

import { useRequiredChartPlugins } from '../plugins/usePlugins.ts';
import { ChartContainer } from '../styled.ts';
import type { ChartJSOrUndefined, ChartProps } from '../types.ts';

type ChartType = 'pie';

const PieChart = React.forwardRef<ChartJSOrUndefined<ChartType>, ChartProps<ChartType>>(function PieChart(props, ref) {
  const { 'data-testid': testId, ...chartProps } = props;
  useRequiredChartPlugins<ChartType>(chartProps.options);

  return (
    <ChartContainer data-testid={testId} style={{ height: chartProps.height ? `${chartProps.height}px` : undefined }}>
      <Pie ref={ref} {...chartProps} />
    </ChartContainer>
  );
});

export default PieChart;
